module.exports = __webpack_public_path__ + "static/media/hand-rock.e42f794e.svg";